export default __webpack_public_path__ + "static/assets/b54d0d27720effd547a1a61651af179b.svg";